import { element } from 'angular';
export var DotDotDotDirective = [
    '$window',
    function ($window) {
        return {
            link: function ($scope, $element, $attributes) {
                $element.addClass('dotdotdot');
                $scope.truncated = false;
                $scope.clicked = false;
                $scope.calculate = function (apply) {
                    var $contentElement = element('.dotdotdot__content', $element);
                    var contentHeight = $contentElement.height();
                    var innerContentHeight = $contentElement
                        .children()
                        .first()
                        .height();
                    $scope.truncated = $scope.truncated ? $scope.truncated : innerContentHeight > contentHeight;
                    if (apply) {
                        $scope.$apply();
                    }
                };
                $scope.toggleTruncation = function () {
                    if (!$scope.clicked) {
                        $scope.clicked = !$scope.clicked;
                    }
                };
                element($window).on('resize', function () {
                    $scope.truncated = false;
                    $scope.calculate(true);
                });
                $scope.$watch(function () {
                    $scope.calculate();
                });
            },
            restrict: 'E',
            scope: {
                readLessText: '@',
                readMoreText: '@',
            },
            template: "\n        <div class=\"dotdotdot__content\" \n             ng-transclude\n             ng-class=\"{ 'dotdotdot__content--clicked': clicked, 'dotdotdot__content--truncated': truncated }\" \n             ng-click=\"toggleTruncation()\">\n        </div>\n        <label ng-show=\"truncated\" class=\"dotdotdot__show-more-button\">\n            <input type=\"checkbox\" ng-model=\"clicked\" />\n            <small ng-show=\"clicked\" ng-cloak ng-bind=\"readLessText\"></small>\n            <small ng-hide=\"clicked\" ng-cloak ng-bind=\"readMoreText\"></small>\n        </label>\n      ",
            transclude: true,
        };
    },
];
